<script setup>
import { IconWarranty24, IconLinkExternal16 } from '@fabric-ds/icons/vue'
</script>

<template>
  <div>
    <h3>Bekymringsfritt salg med bruktbilgaranti <icon-warranty-24 class="text-blue-600 inline ml-4" /></h3>
    <p>Med bruktbilgaranti fra If Skadeforsikring slipper du å tenke på problemer som kan oppstå etter at du har solgt bilen. <b>Garantien forutsetter at du signerer kontrakt via Smidig Bilhandel.</b></p>
    <a
      href="/okonomi/bruktbilgaranti?seller=true"
      target="_blank"
      class="flex items-center text-12 font-bold antialiased mt-12 mb-8"
    ><span class="mr-8">Les mer og se vilkår</span> <icon-link-external-16 /></a>
  </div>
</template>
